
import { getDownloadURL, listAll, ref } from 'firebase/storage';
import {storage} from '../Firebase';




export  const brochureDownload=(path,brochure_link)=>{
    getDownloadURL(ref(storage, path))
    .then((url) => {
      
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = (event) => {
        const blob = xhr.response;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = brochure_link;
        link.click();
        URL.revokeObjectURL(link.href);
      };
      xhr.open('GET', url);
      xhr.send();
    })
    .catch((error) => {
      console.log(error)
    });
};

export const getAllPhotos=(path)=>{
  const listRef=ref(storage, `galerie-corporate/${path}`);
  listAll(listRef).then((res)=>{
    res.items.forEach((itemRef)=>{
      getDownloadURL(itemRef)
      .then((url) => {
        const path=itemRef._location.path_.split('/')[2].split('.')[0]
        const img = document.getElementById(path);
        try{
          img.setAttribute('src', url);
        }catch(error){}
     
      })
      .catch((error) => {
        // Handle any errors
        console.log(error)
      });
    })
  })
};

export const getSingleImage=(path,id)=>{
  getDownloadURL(ref(storage, `galerie-corporate/${path}`))
  .then((url) => {
    const img = document.getElementById(id);
    try{
      img.setAttribute('src', url);
    }catch(error){}

  })
  .catch((error) => {
    // Handle any errors
    console.log(error)
  });
};

// Promise-returning counterparts to getAllPhotos/getSingleImage, for
// callers (like PortfolioMap.js's hover popups) that need the resolved URL
// itself rather than a DOM element to patch — the DOM-patching versions
// silently no-op when the target element doesn't exist yet at fetch-resolve
// time, which is exactly the case for markup that only mounts on hover.
export const getAllPhotoUrls = (path) => {
  const listRef = ref(storage, `galerie-corporate/${path}`);
  return listAll(listRef).then((res) =>
    Promise.all(
      res.items.map((itemRef) =>
        getDownloadURL(itemRef)
          .then((url) => [itemRef._location.path_.split('/')[2].split('.')[0], url])
          .catch(() => null)
      )
    ).then((entries) => Object.fromEntries(entries.filter(Boolean)))
  );
};

export const getSingleImageUrl = (path) =>
  getDownloadURL(ref(storage, `galerie-corporate/${path}`)).catch(() => null);

